import { ComponentProps, ReactNode } from "react";

import { Text } from "@design-system/Text/Text";

import classes from "./CardHeaderTitle.module.css";

type Size = "sm" | "md" | "lg";

type Props = {
  children: ReactNode;
  alignSelf?: "start" | "center" | "end" | "unset";
  size?: Size;
};

const mapSizeToFontSize: Record<Size, ComponentProps<typeof Text>["size"]> = {
  sm: 12,
  md: 14,
  lg: 16,
} as const;

export const CardHeaderTitle = ({
  alignSelf = "center",
  size = "md",
  ...props
}: Props) => {
  return (
    <div className={classes.container} style={{ alignSelf }}>
      <Text
        size={mapSizeToFontSize[size]}
        weight={800}
        color="primary"
        spacing="relaxed"
        uppercase
        {...props}
      />
    </div>
  );
};
